import Vue from 'vue'
import Router from 'vue-router'

import firebase from 'firebase/app';
import 'firebase/auth';
import axios from 'axios'
import CryptoJS from "crypto-js";
Vue.use(Router)

// Route components load as per-route chunks; the entry only carries the shell.
const PageNotFound = () => import(/* webpackChunkName: "page-not-found" */ '@/components/404.vue')
const rewardMessage = () => import(/* webpackChunkName: "reward-message" */ '@/components/wv-reward-message.vue')
const relationshipMapping = () => import(/* webpackChunkName: "relationship-mapping" */ '@/components/wv-relationship-mapping.vue')
const monthlyInsights = () => import(/* webpackChunkName: "monthly-insights" */ '@/components/wv-monthly-insights.vue')
const quarterlyInsights = () => import(/* webpackChunkName: "quarterly-insights" */ '@/components/wv-quarterly-insights.vue')
const documentDeveloper = () => import(/* webpackChunkName: "document-developer" */ '@/components/document-developer.vue')
const weeklyInsights = () => import(/* webpackChunkName: "weekly-insights" */ '@/components/wv-weekly-insights.vue')
const dailyInsights = () => import(/* webpackChunkName: "daily-insights" */ '@/components/wv-daily-insights.vue')
const questionDetails = () => import(/* webpackChunkName: "question-details" */ '@/components/wb-question-details.vue')
const verification = () => import(/* webpackChunkName: "verify-email-report" */ '@/components/wv-verify-email-report.vue')
const imageCapture = () => import(/* webpackChunkName: "image-capture" */ '@/components/image-capture.vue')
const enableAIAssist = () => import(/* webpackChunkName: "enable-ai-assist" */ '@/components/wv-enable-ai-assist.vue')
const recognition = () => import(/* webpackChunkName: "recognition" */ '@/components/wv-recognition-email.vue')
const peerFeedback = () => import(/* webpackChunkName: "peer-feedback" */ '@/components/wv-peer-feedback-email.vue')
const companyHealth = () => import(/* webpackChunkName: "company-health" */ '@/components/company-health-status.vue')
const performanceSummaryReport = () => import(/* webpackChunkName: "performance-summary" */ '@/components/performance-summary-report.vue')
const highPerformingManagers = () => import(/* webpackChunkName: "high-performing-managers" */ '@/components/high-performing-managers.vue')

const userData = localStorage.getItem('userData')
let user;
try {
  user = (userData)?atob(userData):null
  user = JSON.parse(user)
} catch (error) {

}


const routes = new Router({
  mode: 'history',
  routes: [
    {
      path: '/document-developer', component: documentDeveloper,
    },
    {
      path: "/relationship-mapping", component: relationshipMapping
    },
    {
      path: "/reward-message", component: rewardMessage
    },
    {
      path: "/monthly-insights",
      component: monthlyInsights
    },
    {
      path: "/quarterly-insights",
      component: quarterlyInsights
    },
    {
      path: "/company-health-status/:id",
      component: companyHealth
    },
    {
      path: "/performance-summary-report/:id",
      component: performanceSummaryReport
    },
    {
      path: "/weekly-insights/:id",
      component: weeklyInsights
    },
    {
      path: "/daily-insights/:id",
      component: dailyInsights
    },
    {
      path: "/daily-insights-detail/:id",
      component: questionDetails
    },
    {
      path: "/verify-email-report/:id",
      component: verification
    },
    {
      path: "/image-capture/recognition-with-core-values",
      component: imageCapture
    },
    {
      path: "/enable-ai-assist",
      component: enableAIAssist
    },
    {
      path: "/recognition/:id",
      component: recognition
    },
    {
      path: "/peerfeedback/:id",
      component: peerFeedback
    },
    {
      path: "/high-performing-managers/:id",
      component: highPerformingManagers
    },
    {
      path: "*", component: PageNotFound,
    }
   
  ]
})
routes.beforeEach(async (to, from, next) => {
  const themeColor = document.querySelector('meta[name="theme-color"]') || document.createElement('meta');
  themeColor.setAttribute('name', 'theme-color');
  themeColor.setAttribute('content', '#6D27BF');
  document.head.appendChild(themeColor);

  const appleStatusBar = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]') || document.createElement('meta');
  appleStatusBar.setAttribute('name', 'apple-mobile-web-app-status-bar-style');
  appleStatusBar.setAttribute('content', '#6D27BF');
  document.head.appendChild(appleStatusBar);

  const path = {
    "/login": "Login",
    "/pincode": "Pincode",
    "/insights": "Insights",
    "/": false,
    "/members": "Members",
    "/newmembers": "Members",
    "/power-ups": "Power Ups",
    "/relationship-mapping": "Relationship Mapping",
    "/reward-message": "Reward Message",
    "/monthly-insights": "Monthly Insights",
    "/quarterly-insights": "Quarterly Insights",
    "/Daily-insights": "Daily Insights",
    "/weekly-insights": "weekly Insights",
    "/Daily-insights-detail": "Daily Insights Detail",
    "/company-health-status": "company health status",
    "/performance-summary-report": "Performance Summary Report",
    "/high-performing-managers": "High Performing Managers",
  }
  const currentPate = to.path
  if (path[currentPate]) {
    document.title = `My Happily - ${path[currentPate]}`
  }else if(to.path.includes('company-health-status')){
    const _url=(to.path.split("/")[2]).toString()
    let decoded = decodeURIComponent(_url);
    let bytes = CryptoJS.AES.decrypt(
      decoded,'company-health-status');
     let name = '';
     let originalText = bytes.toString(CryptoJS.enc.Utf8);
    if (originalText) {
       name = originalText.split("||")[1];
    }
    document.title = "Organization Status for "+name
  }else {
    document.title = "My Happily"
  }

  if (to.matched.some(record => record.meta.auth)) {
    if (!firebase.auth().currentUser) {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      next({
        path: '/login'
      })
    } else {
      if(user && user.company){
        const company = (await firebase.database().ref(`/company/${user.company}`).once('value')).val()
        if(company && company.ips){
          let ip = '';
          const url = 'https://api.ipify.org?format=json'
          await axios.get(url).then(response => {
            ip = response.data.ip
          })
          .catch(function (error) {
              console.log(error);
          });
          if(!company.ips.includes(ip)){
            firebase.auth().signOut();
            localStorage.removeItem("userData");
            next({
              path: '/login'
            })
          }
        }
      }
      next()
    }
  } else {
    next()
  }
})
export default routes